import BlogImage1 from 'images/news/blogs/avia-pet-adoption-tangtang/1.webp'
import BlogImage2 from 'images/news/blogs/avia-pet-adoption-tangtang/2.webp'
import BlogImage3 from 'images/news/blogs/avia-pet-adoption-tangtang/3.webp'
import BlogImage4 from 'images/news/blogs/avia-pet-adoption-tangtang/4.webp'
import CoverImage from 'images/news/blogs/avia-pet-adoption-tangtang/cover.webp'
import { TextLink } from '../../../components'
import { joinDomain } from '../../../utils'
import { NewsCategory, NewsItem } from '../home'
import { AviaAnimalRescueJiabaoRoute, AviaPetAdoptionTangtangRoute } from '../route'
import { BlogData, BlogModule } from './const'

export const AviaPetAdoptionTangtang: BlogData = {
  key: 'avia-pet-adoption-tangtang',
  title: 'Meet Our Office Cats: Tangtang, Our Sweetest Fighter',
  tag: NewsCategory.SocialResponsibility,
  date: 'Aug 08, 2025',
  content: [
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          At Avia, we believe that an office with a cat is an office with a little more warmth, and a little more
          connection.
          <br />
          <br />
          In 2023, our founder Vickie launched the “Office Cat” initiative—a program rooted in her lifelong love for
          animals and deep commitment to giving back. Long before our new office was finished, she had already reserved
          a dedicated “cat room” in the renovation plans. Her goal: to provide a forever home not for picture-perfect
          pets, but for animals who truly needed to be rescued.
          <br />
          <br />
          We partnered with a 100% non-profit cat rescue organization in Beijing—run entirely by volunteers without any
          commercial sponsorship. Together, we began an adoption journey focused not on appearances, but on compassion.
          <br />
          <br />
          That’s how Tangtang came into our lives.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage1,
      },
    },
    {
      type: BlogModule.Title,
      value: <>A Tiny, Injured Stray with One Eye — We Named Him “Tangtang”</>,
    },

    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Tangtang was barely 3 months old when he was rescued from the outskirts of Tangshan, a city in northern China.
          <br />
          <br />
          He was so frail he looked like a little mouse. His right eye had ruptured from trauma—possibly from a fight
          with other strays, or worse, human abuse. Regardless of the cause, he was found in critical condition.
          <br />
          <br />
          That night, volunteers drove overnight from Beijing to save him.
          <br />
          <br />
          After emergency surgery and weeks of recovery, Tangtang survived. Though he lost one eye, his spirit remained
          bright. He grew stronger, gained weight, and—perhaps most remarkably—never lost his trust in humans.
          <br />
          <br />
          He was named “Tangtang” partly after his birth city, Tangshan—but also because in Chinese, “Tangtang” means
          “Sugar”, a name that perfectly captured the quiet, comforting sweetness he brought into our lives through{' '}
          <strong>pet adoption</strong>.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage2,
      },
    },
    {
      type: BlogModule.Title,
      value: <>Tangtang Is a Cat, but He Loves Like a Dog</>,
    },

    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Tangtang is a chubby British Shorthair with a soft, round face. Despite his missing eye, he looks like a
          little angel—always calm, always smiling.
          <br />
          <br />
          He never hisses, never hides. On his first day at Avia, he curled up in a cozy corner of the cat room and
          began purring contentedly. It was as if he knew he was finally home.
          <br />
          <br />
          He’s also unusually affectionate. He’ll nuzzle your legs when you’re walking by, or hop into your lap during
          meetings. Some say he acts more like a golden retriever than a cat.
          <br />
          <br />
          When someone is working late, Tangtang will quietly sit nearby. When someone’s having a rough day, he’ll offer
          his silent, comforting presence.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage3,
      },
    },
    {
      type: BlogModule.Title,
      value: <>Tangtang is the quietest, warmest brand ambassador we’ve ever had.</>,
    },

    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Tangtang isn’t just a pet—he’s a symbol of our values.
          <br />
          <br />
          He reminds us why we started the Office Cat initiative: to give neglected animals a second chance, and to
          bring purpose-driven connection into the workplace.
          <br />
          <br />
          Today, he lives with Jiabao, another rescued cat, in the heart of our office. They’re more than
          mascots—they’re companions, emotional anchors, and a daily reminder of what it means to care.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage4,
      },
    },
    {
      type: BlogModule.Title,
      value: <>With Tangtang in the office, the space feels more like home. </>,
    },

    {
      type: BlogModule.Paragraph,
      value: (
        <>
          He reminds us—every single day—that kindness isn’t measured by grand gestures, but by quiet consistency. That
          showing up, even if you’re small or scarred, matters. And that sometimes, the most unexpected souls can become
          the heart of a company. We also welcomed another adopted cat, Jiabao, check out his heartwarming{' '}
          <TextLink href={AviaAnimalRescueJiabaoRoute}>pet adoption story in our latest blog</TextLink>.
        </>
      ),
    },
  ],
  more: [],
  path: joinDomain(AviaPetAdoptionTangtangRoute),
}

export const AviaPetAdoptionTangtangNews: NewsItem = {
  id: 17,
  image: CoverImage,
  breadcrumb: [AviaPetAdoptionTangtang.tag, AviaPetAdoptionTangtang.date],
  title: AviaPetAdoptionTangtang.title,
  url: AviaPetAdoptionTangtang.path,
}
